import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const GroupCategory = () => {
  const dispatch = useDispatch();
  const groupCategories = useSelector(
    (state) => state.productSales.selectedFilters.group_categories
  );

  return (
    <ToggleableButton
      isRadio
      isActive={groupCategories === 2}
      title="product-sales-group-category"
      onClick={(data) => dispatch(actionCreators.updateGroupCategory(data))}
    />
  );
};

export default GroupCategory;
